import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Button, Card, CardBody, Media } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan, faCertificate, faExclamationTriangle, faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import Avatar from '../../common/Avatar'
import { PROVIDER_STATUS, storageUrl } from '../marketplaceConstants'

const STATUS_DETAIL = {
  pending: {
    icon: faHourglassHalf,
    color: 'warning',
    text: 'Estamos revisando tus documentos. Ya puedes preparar tus servicios: se mostrarán en el Marketplace cuando aprobemos tu perfil.'
  },
  rejected: {
    icon: faExclamationTriangle,
    color: 'danger',
    text: 'No pudimos verificar tu perfil. Corrige tus documentos para que lo revisemos de nuevo.'
  },
  verified: {
    icon: faCertificate,
    color: 'success',
    text: 'Tienes el Sello Homelan. Tus servicios publicados se muestran en el Marketplace.'
  },
  suspended: {
    icon: faBan,
    color: 'danger',
    text: 'Tu perfil está suspendido: tus servicios no se muestran en el Marketplace. Si tienes dudas, contacta al equipo de Homelan.'
  }
}

const ProviderStatusCard = ({ profile, showProfileLink = true }) => {
  const status = PROVIDER_STATUS[profile.status] || PROVIDER_STATUS.pending
  const detail = STATUS_DETAIL[profile.status] || STATUS_DETAIL.pending

  return (
    <Card className="mb-3">
      <CardBody>
        <Media className="align-items-center flex-wrap">
          <Avatar
            src={storageUrl(profile.photo)}
            name={profile.display_name}
            size="3xl"
            rounded={profile.type === 'company' ? 'soft' : 'circle'}
            className="mr-3 mb-2 mb-sm-0"
          />
          <Media body className="mb-2 mb-sm-0">
            <h5 className="mb-1">
              {profile.display_name}
              {profile.status === 'verified' && (
                <FontAwesomeIcon icon={faCertificate} className="text-primary ml-2" title="Sello Homelan" />
              )}
            </h5>
            <p className="fs--1 text-600 mb-2">{profile.type === 'company' ? 'Empresa' : 'Persona natural'}</p>
            <Badge color={`soft-${status.color}`} pill>
              <FontAwesomeIcon icon={detail.icon} className="mr-1" />
              {status.label}
            </Badge>
          </Media>
          {showProfileLink && profile.status === 'rejected' && (
            <Button tag={Link} to="/provider/profile" color="danger" size="sm" className="ml-sm-auto">
              Corregir documentos
            </Button>
          )}
        </Media>
        <p className={`fs--1 mb-0 mt-3 text-${detail.color === 'warning' ? '700' : detail.color}`}>{detail.text}</p>
        {['rejected', 'suspended'].includes(profile.status) && profile.rejection_reason && (
          <p className="fs--1 mb-0 mt-2">
            <b>Motivo:</b> {profile.rejection_reason}
          </p>
        )}
      </CardBody>
    </Card>
  )
}

export default ProviderStatusCard
